import React from 'react'
//=======Material UI
import Grid from '@material-ui/core/Grid'
import useTheme from '@material-ui/core/styles/useTheme'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import useCloseProjectEditAfterReview from './useCloseProjectEditAfterReview'
import Researcher from './researcher/researcher'
import Officer from './officer/officer'
import useCheckPermission from '../../../../../utilities/checkPermission'
import Dialog from '../../../../../control/dialog/dialog'
import useTranslate from '../../../../../i18n/useTranslate'
import Button from '../../../../../control/button/button'

import ButtonSubmittedWithdraw from '../../page/_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'

type CloseProjectEditAfterReviewViewType = ReturnType<typeof useCloseProjectEditAfterReview> &
    Omit<CloseProjectEditAfterType, 'projectMode'>
const CloseProjectEditAfterReviewView: React.FC<CloseProjectEditAfterReviewViewType> = (props) => {
    const {
        projectMode,
        configDialog,
        isViewMode,
        projectData,
        onRefDialog,
        onCallbackSaveComplete,
        onClickBackToSearch,
    } = props
    const checkPermission = useCheckPermission()
    const isUserResearcher = checkPermission.isUserResearcher()
    const translate = useTranslate()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData)

    const renderUserRoleComponent = () => {
        if (isUserResearcher) {
            return <Researcher projectMode={projectMode} callbackSaveComplete={onCallbackSaveComplete} />
        } else {
            return <Officer callbackSaveComplete={onCallbackSaveComplete} />
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid container item>
                {renderUserRoleComponent()}
            </Grid>
            {isViewMode && !canUpdateDocument ? (
                <Grid container item justify="space-between" spacing={2}>
                    <Grid item xs={12} sm={'auto'}>
                        <ButtonSubmittedWithdraw gridProps={{ xs: false }} fullWidth={isMobileView ? true : false} />
                    </Grid>
                    <Grid item xs={12} sm={'auto'}>
                        <Button color="primary" onClick={onClickBackToSearch} fullWidth={isMobileView ? true : false}>
                            {translate.get('BUTTON.CLOSE')}
                        </Button>
                    </Grid>
                </Grid>
            ) : null}
            <Dialog onRef={onRefDialog} {...configDialog} />
        </Grid>
    )
}

export type CloseProjectEditAfterType = {
    projectMode: 'CREATE' | 'EDIT'
}
const CloseProjectEditAfterReview: React.FC<CloseProjectEditAfterType> = (props) => {
    const closeProjectModel = useCloseProjectEditAfterReview(props)

    return <CloseProjectEditAfterReviewView {...closeProjectModel} />
}
export default CloseProjectEditAfterReview
